<template>
    <div 
        v-if="!isActivityEnd" 
        id="link-vip-202101" 
        key="activity">
        <Loading 
            v-if="isLoading" 
            :message="loadingText"/>
        <section 
            v-if="ua.kkmh" 
            id="go-back" 
            key="go-back" 
            @click="closeWebview"><img 
                src="./img/go-back.png" 
                alt=""></section>
        <div 
            v-if="isPageShow" 
            key="show-activity">
            <section 
                v-if="ua.kkmh" 
                id="share" 
                key="share" 
                @click="share"><img 
                    src="./img/share.png" 
                    alt=""></section>
            <section 
                id="rules" 
                @click="showDialog"><img 
                    src="./img/rules.png" 
                    alt=""></section>
            <header id="header">
                <img 
                    :key="currentTab" 
                    :src="require(`./img/header.png`)" 
                    class="header-image" 
                    alt="">
            </header>
            <section id="vip-tab">
                <img 
                    src="./img/tab-bg.png" 
                    alt="">
                <div class="tab-vip-icon">
                    <div class="tab-image-wrap">
                        <img
                            :src="kkIcon"
                            class="tab-image" 
                            alt="">
                        <span 
                            :class="[comboClassMap[currentActivity.kkVipCombo]]" 
                            class="vip-type flex_layout flex_xy_center">{{ comboTagMap[currentActivity.kkVipCombo] }}</span>
                    </div>
                    <p class="kkb">{{ kuaikanGoodList[0] ? (kuaikanGoodList[0].kkb_giving ? `送${kuaikanGoodList[0].kkb_giving}KK币` : '' ): '' }}</p>
                </div>
                <p 
                    v-if="activityList[currentTab].activityTips" 
                    class="tab-tips flex_layout flex_xy_center">{{ activityList[currentTab].activityTips }}</p>
            </section>
            <component
                :is="comp"
                :key="currentTab"
                :data="activityList[currentTab]"
                :good="kuaikanGoodList[currentTab]"
                @open_content_callback="openContentCallback"
                @open_vip_callback="openVip"
                @click_banner_callback="clickBannerCallback"
                @to_assign_page_callback="toAssignCenter" />
        </div>
        <DialogComp 
            ref="refDialog" 
            :rules="currentActivity.rules" 
            title="活动规则" />
        <Cashdesk
            ref="cashdesk"
            :visible.sync="visible_cashdesk"
            :param="param_cashdesk"
            @dialogOpen="receiveCashdeskDialogOpen"
            @dialogClose="receiveCashdeskDialogClose"
            @payMessage="receiveCashdeskPayMessage"
            @errorMessage="receiveCashdeskErrorMessage"
            @goodData="receiveCashdeskGoodData" />
    </div>
    <div 
        v-else 
        class="end">
        <section 
            id="go-back" 
            key="go-back" 
            @click="closeWebview"><img 
                src="./img/go-back.png" 
                alt=""></section>
        <img 
            src="./img/error.png" 
            alt="" 
            class="error">
        <p class="error-text">{{ endTipsMap[ACTIVITY_STATUS] }}</p>
        <div 
            v-show="ACTIVITY_STATUS == 3" 
            class="flex_layout flex_xy_center error-btn" 
            @click="toAssignCenter">去领取</div>
    </div>
</template>

<script>
import { Cashdesk } from "@kkmh/pays";
import Loading from "./comp/Loading";
import DialogComp from "./comp/Dialog";
import jointImageSuffix from "@kkmh/image-format";
import { tools } from "@/assets/js/SDK_copy/libs/sdk.tools";
import { close_page, share, show_tips } from "@kk/h5-sdk";
import { toast } from "@/assets/fe_js/common/base/fn/message.js";
import { commonAction } from "@/assets/fe_js/common/base/jump/commonAction.js";
import { getKuaikanGood } from "@/api/pay/link_vip_multiple.api.js";
import { getActivityList, getQueryOpenAuth } from "@/api/pay/link_vip_double.api.js";
import v1_fox_horadric_pay from "@/api/name/v1_fox_horadric_pay.api.js";
export default {
    components: { Loading, DialogComp, Cashdesk },
    data() {
        return {
            isPageShow: false,
            isActivityEnd: false,
            PAY_ACTIVITY_NAME: "春节10选6",
            TRIGGER_PAGE: "",
            VIP_TYPE: "",
            CHARGE_ACTIVITY_NAME: "",
            AWARD_NAME: "",
            isSupportIAP: 0, // 运营位是否支持越狱
            isJailbreakPhone: window.__gvalkkmh ? (window.__gvalkkmh.sys ? window.__gvalkkmh.sys.is_jailbroken_phone : false) : false,
            deviceId: window.__gvalkkmh ? (window.__gvalkkmh.sys ? window.__gvalkkmh.sys.device_id : "") : "",
            ua: window.__gvalkkmh ? window.__gvalkkmh.ua : {},
            isLoading: false,
            loadingText: "",
            isLogin: false,
            activityList: [],
            kuaikanGoodList: [],
            comp: () => import("./views/activity"),
            currentTab: 0,
            param_cashdesk: {},
            visible_cashdesk: false,
            ACTIVITY_STATUS: "",
            activityStatusMap: {
                0: "不展示活动 参数或者配置有误",
                1: "正常展示活动",
                2: "不展示活动 未参加过",
                3: "不展示活动 尚有未领取",
                4: "不展示活动 已领完",
            },
            endTipsMap: {
                0: "参数或者配置有误",
                1: "正常展示活动",
                2: "很遗憾, 活动已结束",
                3: "活动已结束! 您已购买会员，请尽快领取哦~",
                4: "很遗憾, 活动已结束",
            },
            kkIcon: require("./img/kk-icon.png"),
            comboTagMap: {
                1: "连续包月",
                2: "月卡",
                3: "季卡",
                4: "年卡",
                5: "半年"
            },
            comboClassMap: {
                1: "auto-renew",
                2: "month",
                3: "season",
                4: "year",
                5: "year"
            },
        };
    },
    computed: {
        currentActivity() {
            return this.activityList[this.currentTab] || {};
        },
        returnVipListClass() {
            let length = this.vipList.length;
            // 有且仅有两个 单独使用
            if (length == 2) return "double flex_y_center flex_x_spacebetween";
            // 先判断数组长度能不能被整除(4比3优先)
            if (length % 4 == 0) return "four flex_wrap flex_xy_center";
            if (length % 3 == 0) return "triple flex_wrap flex_xy_center";
            // 不能整除的取余数大的情况
            return (length % 4 > length % 3) ? "four flex_wrap flex_xy_center" : "triple flex_wrap flex_xy_center";
        },
        returnVipInfoClass() {
            return this.vipList.length == 2 ? "flex_layout flex_x_center flex_y_start flex_flexDirection_column" : "";
        },
        returnVipItemClass(index) {
            return this.vipList.length == 2 ? "flex_layout flex_x_start flex_y_center" : "";
        },
    },
    created () {
        this.currentTab = tools.urlValue().tab || 0;
        this.TRIGGER_PAGE = tools.urlValue().origin || "";
        this.CHARGE_ACTIVITY_NAME = tools.urlValue().activity_name || "";
        this.AWARD_NAME = tools.urlValue().award_name || "";
        this.isSupportIAP = parseInt(tools.urlValue().non_iap_supported || 0);
        this.initPage();
    },
    methods: {
        setCompParam(item={}){
            let good = this.kuaikanGoodList[this.currentTab];
            let coupon = good ? (good.coupon ? (good.coupon.usable_list[0] || {}) : {}) : {};
            this.param_cashdesk = {
                //接口所需字段
                good_type                   : 2,        //必须-int 1.kkb 2.vip
                good_id                     : good.id || 0,        //必须-int 76
                coupon_id                   : coupon.id || "",       //不必须-string【vip】优惠券id
                third_activity              : this.CHARGE_ACTIVITY_NAME,       //不必须-string 活动ID
                coupon_type                 : 1,        //不必须-int【vip半屏】0:使用第一个, 1:使用最大的优惠券 2:待扩充
                comic_id                    : 0,        //不必须-int 漫画id
                topic_id                    : 0,        //不必须-int 专题id
                source_type                 : 0,        //不必须-int 1：签到，2：皇冠，3：作品，4：礼包
                invite_code                 : "",       //不必须-string 邀请码
                vip_source                  : "",       //不必须-string【vip】get_entrance_param协议里获取的vip_source字段
                non_iap_supported_device    : this.isJailbreakPhone,    //是否越狱设备，true表示是
                non_iap_supported           : this.isSupportIAP,        //运营位是否支持越狱，1表示支持
                    
                //埋点所需字段
                cps                         : "",       //不必须-string 下单接口时要传递的字段，也用作埋点上报
                trigger_page                : this.PAY_ACTIVITY_NAME,       //不必须-string 埋点属性TriggerPage
                origin                      : this.TRIGGER_PAGE,       //不必须-string 埋点属性EntranceName
                notice_type                 : "",       //不必须-string【vip】get_entrance_param协议里获取的notice_type字段
                send_comic                  : "",       //不必须-string【vip】定向限免埋点-assign接口中send_comic字段
                free_pay_rate               : "",       //不必须-string【vip】定向限免埋点-assign接口中free_pay_rate字段
                    
                //回掉地址
                redirect_url                : "",       //不必须-string 支付成功之后想跳回的h5地址
                    
                //小程序
                bind_phone                  : 1,        //不必须-int 百度小程序支付前验证是否需要绑定手机号，默认：0 不绑定
                    
                //其他
                comic_price                 : 0,         //不必须-int 需要购买漫画的价格(kkb半屏的title文案：余额不足请充值 or 请充值)
            };
        },
        // 设置组件数据
        clickOpenDialog(){
            this.setCompParam();
            this.visible_cashdesk = true;
        },
        // 获取商品详细信息
        clickGetDetailData(){
            this.setCompParam();
            this.$refs.cashdesk.getGoodData();
        },
        // 收银台组件-接收 : 打开
        receiveCashdeskDialogOpen(){
        },
        // 收银台组件-接收 : 关闭
        receiveCashdeskDialogClose(){
        },
        // 收银台组件-接收 : 支付信息
        receiveCashdeskPayMessage(res){
            let {code, data={}, message=""} = res;
            let params = {
                ButtonName: "立即开通/续费",
                CurrentPrice: this.kuaikanGoodList[this.currentTab] ? this.kuaikanGoodList[this.currentTab].price.real_price : 0,
                MembershipPrdName: this.kuaikanGoodList[this.currentTab] ? this.kuaikanGoodList[this.currentTab].title : ""
            };
            if (code == 200) {
                // 1: 支付成功 2: 支付失败 3:取消 4. 好友代付 5.没有找到对应的商品 6.好友代付回退 .....
                switch(data.pay_status) {
                case 1:
                    // 支付成功
                    this.doTrack("PayActivityBtnClk", {
                        ...params,
                        IsOpenSuccess: 1,
                    });
                    this.initPage();
                    break;
                case 2:
                    // 支付失败
                    this.doTrack("PayActivityBtnClk", {
                        ...params,
                        IsOpenSuccess: 0,
                    });
                    this.initPage();
                    break;
                case 5: 
                    // 没有找到对应商品
                    this.showToast("没有找到对应商品!");
                    break;
                case 7:
                    // 苹果越狱支付
                    if (data.pay_payment.type === 4) {
                        this.showToast("支付环境已刷新, 请重新尝试购买");
                        this.getKuaikanGood(true);
                    }
                }
            }
        },
        // 收银台组件-接收 : 出错
        receiveCashdeskErrorMessage(res){
        },
        // 收银台组件-接收 : vip/kkb 商品信息
        receiveCashdeskGoodData(res){
        },
        async initPage() {
            this.isLogin = !!window.__gvalkkmh.user.id;
            this.getMembership();
            await this.getActivityList();
            await this.getKuaikanGood();
        },
        getMembership() {
            v1_fox_horadric_pay({data_types: "2"}).then(res => {
                if (res.data.code === 200) {
                    this.VIP_TYPE = res.data.data.vip_common.vip_classify;
                    this.doTrack("PayActivityPV");
                }
            }).catch(err => {
                this.showToast(err);
                this.isLoading = false;
            });
        },
        getActivityList() {
            this.isLoading = true;
            let params = {
                activity_name: this.CHARGE_ACTIVITY_NAME,
                award_names: this.AWARD_NAME
            };
            return getActivityList(params).then(res => {
                this.isLoading = false;
                let {code, data, message} = res.data;
                if (code == 401) return this.toLogin("must");
                if (code != 200) return this.showToast(message);
                // 活动状态 影响页面展示 只有等于2 的时候活动正常展示 其余状态展示错误页面 并提示相应文案
                this.ACTIVITY_STATUS = data.activity_status;
                this.isActivityEnd = this.ACTIVITY_STATUS != 1;
                this.isPageShow = true;
                this.activityList = data.home_views.map(item => {
                    item.activityTips = item.words_info.activity_tips_202102;
                    // 奖品唯一标识 用于html做key  也用于开通前查询参数
                    item.awardKey = item.award_name;
                    // 开通提示
                    item.buyTips = item.words_info.buy_tips;
                    // 每人可以开通的总次数
                    item.totalChargeTimes = item.total_charge_count;
                    // 每人已经开通的次数(风控次数)
                    item.chargedTimes = item.risk_count;
                    // 每人剩余的领取次数
                    item.canAssignTimes = item.can_assign_count;
                    // 原价
                    item.originPrice = +item.words_info.origin_price;
                    // 快看商品类型
                    item.kkVipCombo = +item.words_info.kk_vip_combo;
                    item.kkInfoTitle = item.words_info.kk_info_title;
                    // 活动规则
                    item.rules = item.words_info.activity_rules;
                    // 运营位跳转类型
                    item.bannerAction = item.target_info ? (item.target_info.banner_action || {} ) : {};
                    // 运营位图片
                    item.bannerImage = item.image_info ? item.image_info.banner_image : "";
                    // 参与活动的会员列表
                    item.vipList = item.awards.map(vip => {
                        vip.words_info.link_vip_desc = vip.words_info.link_vip_desc ? vip.words_info.link_vip_desc.split(",") : [];
                        // 合作方内容图展示数量取决于 后台配的 link_vip_content_image 真正有值的有几个
                        let imageLength = Object.keys(vip.image_info).filter(img => {
                            return img.includes("link_vip_content_image");
                        }).filter(img => {
                            return vip.image_info[img];
                        }).length;
                        this.$set(vip, "contentList", new Array(imageLength).fill().map((img, index) => {
                            let order = index + 1;
                            return {
                                title: vip.words_info["link_vip_content_title_" + order],
                                image: jointImageSuffix({src: vip.image_info["link_vip_content_image_" + order], width: 200}),
                                target: vip.target_info["link_vip_content_target_" + order] ? vip.target_info["link_vip_content_target_" + order].target_web_url : "",
                            };
                        }));
                        return vip;
                    });
                    // 快看专题数据
                    let kkImageLength = Object.keys(item.image_info).filter(img => {
                        return img.includes("kk_content_image");
                    }).filter(img => {
                        return item.image_info[img];
                    }).length;
                    let kkInfo = {
                        award_icon: this.kkIcon,
                        award_title: "快看漫画",
                        words_info: {
                            link_vip_combo: item.kkVipCombo,
                            link_vip_app: "快看漫画",
                            link_vip_desc: ["KK币礼包","会员提前看","整本限免"],
                        },
                        contentList: new Array(kkImageLength).fill().map((img, index) => {
                            let order = index + 1;
                            return {
                                isKuaikan: true,
                                title: item.words_info["kk_content_title_" + order],
                                image: jointImageSuffix({src: item.image_info["kk_content_image_" + order], width: 200}),
                                target: item.words_info["kk_content_id_" + order]
                            };
                        })
                    };
                    // 会员特权列表
                    item.iconVipList = item.vipList.concat();
                    item.iconVipList.unshift(kkInfo);
                    return item;
                });
            }).catch(err => {
                this.showToast(err);
                this.isLoading = false;
                this.isActivityEnd = true;
            });
        },
        getKuaikanGood(compel_iap = false) {
            this.isLoading = true;
            let data = {
                pay_info: {
                    comic_id: 0, //0, //int 漫画id
                    topic_id: 0, //0, //int 专题id
                    source_type: 0, //0,//int 1：签到，2：皇冠，3：作品，4：礼包
                    invite_code: "", //'',//string 邀请码
                    coupon_id: "", //'', //string 优惠券id
                    third_activity: this.CHARGE_ACTIVITY_NAME, //'2019act', //添加订单接口，所要传入的活动名称参数
                },
                third_activity: this.CHARGE_ACTIVITY_NAME,
                non_iap_supported: this.isSupportIAP, //运营位是否支持越狱，1表示支持
                compel_iap, // 是否强制iap
                non_iap_supported_device: this.isJailbreakPhone,
                platform: this.ua.kkmh ? (this.ua.iphone ? 2 : 1) : "", // 1-安卓，2-ios，3-h5，
            };
            let headers = {
                "X-Device": this.deviceId,
            };
            return getKuaikanGood({ data, headers }).then(res => {
                this.isLoading = false;
                let {code, data, message} = res.data;
                if (code == 401) return this.toLogin("must");
                if (code != 200) return this.showToast(message);
                let goodList = data.members.length ? data.members[0] : [];
                this.kuaikanGoodList = this.activityList.map((item) => {
                    let kkGoodList = goodList.member_goods ? goodList.member_goods.filter(good => good.combo == item.kkVipCombo) : [];
                    return kkGoodList.length ? kkGoodList[0] : {};
                });
            }).catch(err => {
                this.showToast(err);
                this.isLoading = false;
            });
        },
        openVip(isBtnFixed) {
            if (!this.ua.kkmh) return this.openKuaikan();
            this.doTrack("PayActivityBtnClk", {
                ButtonName: "限量抢购" + (isBtnFixed ? "吸底" : "")
            });
            
            if (!this.isLogin) return this.toLogin();
            this.isLoading = true;
            this.loadingText = "正在处理";
            getQueryOpenAuth({
                activity_name: this.CHARGE_ACTIVITY_NAME,
                award_name: this.activityList[this.currentTab].awardKey
            }).then(res => {
                this.isLoading = false;
                this.loadingText = "";
                let {code, data, message} = res.data;
                if (code != 200) return this.showToast(message);
                if (data.code == 200) {
                    this.clickOpenDialog();
                } else {
                    this.showToast(data.message);
                }
            }).catch(err => {
                this.showToast(err);
                this.isLoading = false;
            });
        },
        showToast(text) {
            if (!this.ua.kkmh) return toast(text);
            return show_tips({text, time: 1, style: 1});
        },
        showDialog() {
            if (!this.ua.kkmh) return this.openKuaikan();
            this.$refs.refDialog.show();
        },
        openKuaikan() {
            location.href = "https://u.admki.com/s/9olSg";
        },
        closeWebview() {
            close_page({animation: 1});
        },
        share() {
            let title = "1份价格，多重会员权益！";
            let desc = "开通快看VIP年卡，10家会员任意选6家！";
            let image = this.kkIcon;
            let link = location.href;
            share({
                title,
                desc,
                image,
                link,
                platform: [
                    {name : "QQ", type: 1, link, image, title, desc},
                    {name : "WechatMoments", type: 1, link, image, title, desc},
                    {name : "SinaWeibo", type : 1, link, image, title, desc},
                    {name : "QZone", type : 1, link, image},
                    {name : "Wechat", type: 1, link, image}
                ]
            });
        },
        async toLogin(mode = "need") {
            if (this.isLogin) return;
            // 端内
            if (this.ua.kkmh) {
                if (window.__gvalkkmh.user.id) return;
                await h5init({login_mode: mode});
                window.__gvalkkmh.user.id && this.initPage();
                return;
            }
            // 小程序
            // if (this.ua.miniprogram) return miniprogramNav('/pages/login/login')
            // 端外
            let webHost = "https://"+ (/kuaikanmanhua/.test(location.host) ? "m.kuaikanmanhua.com" : "m.quickcan.cn");
            location.href = webHost + "/mob/login?redirect=" + encodeURIComponent(location.href);
        },
        openContentCallback(item) {
            if (!this.ua.kkmh) return this.openKuaikan();
            this.doTrack("PayActivityBtnClk", {
                ButtonName: "点击封面",
                TopicName: item.title
            });
            if (!item.target) return;
            if (item.isKuaikan) {
                if (this.ua.kkmh) return commonAction({actionType: 2, actionId: item.target});
                location.href = location.origin + "/kuaikanmanhua.com/mobile/" + item.target + "/list/";
            } else {
                if (this.ua.kkmh) return commonAction({actionType: 1, actionUrl: item.target});
                location.href = item.target;
            }
        },
        clickBannerCallback() {
            if (!this.ua.kkmh) return this.openKuaikan();
            this.doTrack("PayActivityBtnClk", {
                ButtonName: "通栏banner"
            });
            let data = this.activityList[this.currentTab];
            let action = data.target_info ? (data.target_info.banner_action || {}) : {};
            if (!action.action_type) return;
            commonAction({
                actionType: action.action_type,
                actionId: action.target_id,
                actionUrl: action.target_web_url
            });
        },
        toAssignCenter(isBtnFixed) {
            if (!this.ua.kkmh) return this.openKuaikan();
            this.doTrack("PayActivityBtnClk", {
                ButtonName: `领取权益${isBtnFixed ? "吸底" : ""}`
            });
            let url = `${location.origin}/native_pay_vip_link_vip_multiple_list.html?conf2fullscreen=1&conf2scrollwhitearea=1&statusbar=0&origin=${this.TRIGGER_PAGE}`;
            if (this.ua.kkmh) return commonAction({actionType: 1, actionUrl: url});
            location.href = url;
        },
        doTrack(eventName, params) {
            if (!window.__gvalkkmh.is_track_identified) return;
            let prototype = {
                PayActivityName: this.PAY_ACTIVITY_NAME,
                TriggerPage: this.TRIGGER_PAGE,
                MembershipClassify: this.VIP_TYPE,
                H5Page: location.href,
            };
            // 端外埋点
            if (!this.ua.kkmh) {
                prototype.CurrentPlatform = this.returnTrackPlatform();
            }
            if (params) {
                prototype = Object.assign(prototype, params);
            }
            kksa.track(eventName, prototype);
        },
    }
};
</script>

<style lang="scss" scoped>
@import '@/assets/sass/vws.scss';
.end {
    position: fixed;
    left: 0;
    top: 0;
    padding-top: vws(563px);
    width: 100vw;
    height: 100vh;
    background: #fff;
}
.error {
    margin: 0 auto;
    padding-bottom: vws(26px);
    width: vws(219px);
    height: vws(188px);
}
.error-text {
    text-align: center;
    font-size: vws(34px);
    color: #9C9C9C;
    line-height: 1.15;
}
.error-btn {
    margin: 0 auto;
    margin-top: vws(50px);
    width: vws(380px);
    height: vws(80px);
    font-weight: bold;
    line-height: 1.15;
    color: #3E2322;
    border-radius: vws(40px);
    background: -moz-linear-gradient(top, #F4D870 0%, #F9B25F 100%);
    background: -webkit-gradient(linear, left top, left bottom, color-stop(0%,#F4D870), color-stop(100%,#F9B25F));
    background: -webkit-linear-gradient(top, #F4D870 0%,#F9B25F 100%);
    background: -o-linear-gradient(top, #F4D870 0%,#F9B25F 100%);
    background: -ms-linear-gradient(top, #F4D870 0%,#F9B25F 100%);
    background: linear-gradient(to bottom, #F4D870 0%,#F9B25F 100%);
}
#go-back {
    z-index: 1111; //高于header img 高于loading
    position: absolute;
    top: vws(52px);
    left: vws(30px);
    width: vws(64px);
    height: vws(64px);
}
#share {
    z-index: 1; //高于header img
    position: absolute;
    top: vws(55px);
    right: vws(23px);
    width: vws(141px);
    height: vws(58px);
}
#rules {
    z-index: 2; //高于vip-inner 高于vip-tab
    position: absolute;
    top: vws(298px);
    right: 0;
    width: vws(48px);
    height: vws(155px);
}
#header {
    min-height: vws(314px);
    background: #23245E;
}
#vip-tab {
    z-index: 1;
    position: relative;
    margin: 0 auto;
    width: vws(750px - 17px * 4);
    height: vws(163px);
    .tab-vip-icon {
        position: absolute;
        left: 0;
        top: vws(20px);
        width: vws(190px);
        text-align: center;
        .kkb {
            text-align: center;
            font-size: vws(24px);
            color: #000;
            line-height: 1.15;
            font-weight: bold;
        }
        .tab-image-wrap {
            position: relative;
            display: block;
            margin: 0 auto;
            margin-bottom: vws(7px);
            width: vws(87px);
            height: vws(87px);
        }
        .vip-type {
            position: absolute;
            right: vws(-13px);
            top: vws(-10px);
            padding: vws(4px) vws(10px);
            height: vws(16px);
            background: #4F9FFB;
            border-radius: vws(14px) vws(14px) vws(14px) vws(2px);
            font-size: vws(14px);
            font-weight: 600;
            color: #fff;
            &.year {
                background: #FF4E4E;
            }
            &.month {
                background: #4E6BE6;
            }
            &.season {
                background: #019E99;
            }
        }
    }
    .tab-tips {
        position: absolute;
        right: vws(37px);
        top: vws(110px);
        padding: 0 vws(30px);
        height: vws(32px);
        border-radius: vws(16px);
        background: #6164DC;
        font-size: vws(24px);
        color: #fff;
        font-weight: bold;
        line-height: 1.15;
    }
}
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.2s ease;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
}
</style>


// WEBPACK FOOTER //
// src/pages/act/202102/link_vip/app.vue